import { useEffect, useRef } from "react";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
export const googleMapsApiKey = "AIzaSyDtGfe-uCxF3xUD7KBkv8hYcO9UWQiLw3I";
const MapContainer = ({ Latitude, Longitude }: any) => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: googleMapsApiKey,
  });
  const mapNode = useRef<any>(null);
  useEffect(() => {
    if (isLoaded) {
      // 在这里可以访问mapNode.current来进行地图的操作
    }
  }, [isLoaded]);

  return (
    !!isLoaded && (
      <GoogleMap
        mapContainerStyle={{
          width: "100%",
          height: "100%",
        }}
        center={{ lat: Latitude, lng: Longitude }}
        zoom={8}
        ref={mapNode}
      />
    )
  );
};

export default MapContainer;
